// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14.5 8C14.5 11.59 11.59 14.5 8 14.5C4.41 14.5 1.5 11.59 1.5 8C1.5 4.41 4.41 1.5 8 1.5C11.59 1.5 14.5 4.41 14.5 8Z',
  'M6.3 6.3C6.3 5.39 7.06 4.85 8.05 4.85C9.04 4.85 9.7 5.4 9.7 6.2C9.7 6.91 9.16 7.26 8.64 7.6C8.28 7.84 8 7.94 8 8.25',
  'M8.06 10.48H7.94V10.35H8.06V10.48Z',
];
